export default "__VITE_ASSET__b075ed60__"